<template>
  <DsShowcase title="MultiselectPlayV2" description="Multiselect com tags, busca, select all, limite de tags visíveis e taggable.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: Array&lt;{ id, label }&gt;</code></p>
      <div class="tw:max-w-lg tw:space-y-3">
        <MultiselectPlayV2 v-model="val1" :options="categories" placeholder="Selecione categorias" />
        <p class="tw:text-xs tw:opacity-50">Selecionados: {{ val1.map(v => v.label).join(', ') || '—' }}</p>
      </div>
    </section>

    <!-- PROP: enableSelectAll -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">enableSelectAll</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe botão "Selecionar todos"</p>
      <div class="tw:max-w-lg">
        <MultiselectPlayV2 v-model="val2" :options="skills" :enable-select-all="true" placeholder="Habilidades" />
      </div>
    </section>

    <!-- PROP: limit -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">limit</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — máximo de tags visíveis antes de mostrar "+N". Padrão: <code>3</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <MultiselectPlayV2 v-model="valLimit" :options="skills" :limit="2" placeholder="Limite 2 tags" />
      </div>
    </section>

    <!-- PROP: max -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">max</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — máximo de itens selecionáveis</p>
      <div class="tw:max-w-lg">
        <MultiselectPlayV2 v-model="val3" :options="skills" :max="3" placeholder="Máximo 3 itens" />
        <p class="tw:text-xs tw:mt-2 tw:opacity-50">{{ val3.length }}/3 selecionados</p>
      </div>
    </section>

    <!-- PROP: taggable -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">taggable</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — permite criar novas opções digitando</p>
      <div class="tw:max-w-lg">
        <MultiselectPlayV2 v-model="val4" :options="categories" :taggable="true" placeholder="Adicione tags..." />
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'sm' | 'md' | 'lg'</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <MultiselectPlayV2 v-model="valSm" :options="categories" size="sm" placeholder="Small" />
        <MultiselectPlayV2 v-model="valMd" :options="categories" size="md" placeholder="Medium" />
        <MultiselectPlayV2 v-model="valLg" :options="categories" size="lg" placeholder="Large" />
      </div>
    </section>

    <!-- PROP: error / disabled / skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">error / disabled / skeleton</h2>
      <div class="tw:max-w-lg tw:space-y-4">
        <MultiselectPlayV2 :options="categories" :error="true" placeholder="Com erro" />
        <MultiselectPlayV2 :options="categories" :disabled="true" :model-value="[categories[0]]" />
        <MultiselectPlayV2 :options="categories" :skeleton="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { MultiselectPlayV2 } from "@/components/atomic"

const categories = [
  { id: 'marketing', label: 'Marketing' },
  { id: 'vendas', label: 'Vendas' },
  { id: 'tech', label: 'Tecnologia' },
  { id: 'design', label: 'Design' },
  { id: 'rh', label: 'Recursos Humanos' },
]

const skills = [
  { id: 'vue', label: 'Vue.js' },
  { id: 'react', label: 'React' },
  { id: 'ts', label: 'TypeScript' },
  { id: 'node', label: 'Node.js' },
  { id: 'python', label: 'Python' },
  { id: 'go', label: 'Go' },
  { id: 'rust', label: 'Rust' },
  { id: 'css', label: 'CSS' },
]

const val1 = ref([])
const val2 = ref([])
const val3 = ref([])
const val4 = ref([])
const valLimit = ref([skills[0], skills[1], skills[2], skills[3]])
const valSm = ref([])
const valMd = ref([])
const valLg = ref([])
</script>
